import type { TourStep } from '../types';

export const invitingMembersSteps: TourStep[] = [
  {
    target: '[data-tour="team-section"]',
    title: 'Growing Your Team',
    content:
      'Adding members lets you share appraisals, coordinate schedules, and manage assignments together. Let\'s walk through the invitation process.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="team-invite"]',
    title: 'Send an Invitation',
    content:
      'Click here to invite someone by email. Select their role — Appraiser, Trainee, or Admin — and they\'ll receive a link to join your team.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I see the invite button',
  },
  {
    target: '[data-tour="team-members"]',
    title: 'Roles & Permissions',
    content:
      'Owner: full control including billing. Admin: manage members and settings. Appraiser: create and share reports. Trainee: limited access with supervisor oversight.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="team-members"]',
    title: 'Pending Invitations',
    content:
      'Pending invites show with a "Pending" badge. The invitee gets an email with a join link. You can resend or revoke anytime.',
    placement: 'bottom',
    spotlightClicks: true,
  },
];
